var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Popover } from '@material-ui/core';
import { makeStyles, alpha } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
    root: {},
    paper: {
        marginTop: 12,
        marginLeft: 4,
        overflow: 'inherit',
        boxShadow: theme.shadows[25].z20,
        border: `solid 1px ${theme.palette.grey[5008]}`
    },
    arrow: {
        [theme.breakpoints.up('sm')]: {
            top: -7,
            zIndex: 1,
            width: 12,
            right: 20,
            height: 12,
            content: "''",
            position: 'absolute',
            borderRadius: '0 0 4px 0',
            transform: 'rotate(-135deg)',
            background: theme.palette.background.paper,
            borderRight: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
            borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`
        }
    }
}));
export const PopoverMenu = (_a) => {
    var { children, width, className } = _a, other = __rest(_a, ["children", "width", "className"]);
    const classes = useStyles();
    return (React.createElement(Popover, Object.assign({ getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, className: className, classes: {
            root: classes.root,
            paper: classes.paper
        } }, other),
        React.createElement("span", { className: classes.arrow }),
        React.createElement(Box, { sx: { width: width, maxWidth: '100%' } }, children)));
};
//# sourceMappingURL=PopoverMenu.js.map